import { Modal } from "antd";
// import { nanoid } from "nanoid";
import { v4 as uuidv4 } from "uuid";
import {useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { addPlayer, updatePlayer } from "../../../../redux/playersSlice";
import { IPlayer } from "../../../types";
import { EmptyPlayer } from "../GamePlayers";
import  AddName  from "./AddName";
import AddPhoto from "./AddPhoto";
import "./Modal.css";

interface Props{
    open: boolean;
    onCancel: () => void;
    playerToBeUpdated: IPlayer | null | EmptyPlayer;
}
type StepState = 'name' | 'photo';

const ModalAddPlayer = ({ open, onCancel, playerToBeUpdated}: Props) => {
    const [name, setName] = useState(playerToBeUpdated?.name || "");
    const [userUpdateStep, moveToUpdateStep] = useState<StepState>('name');

    useEffect(() => {
        setName(playerToBeUpdated?.name || "");
        moveToUpdateStep('name');
    }, [open, playerToBeUpdated?.name]);

    const dispatch = useDispatch();

    const onNameSet = (name: string) => {
        setName(name);
        moveToUpdateStep('photo');
    };

    const onPhotoSet = (imgSrc: string) => {
        handleAddPlayer(imgSrc, name);
        onCancel();
    };
    const handleAddPlayer = (imgSrc: string, name: string) => {
        if (playerToBeUpdated) {
            const action = playerToBeUpdated.id === null ? addPlayer : updatePlayer;
            const id = playerToBeUpdated.id === null ? uuidv4() : playerToBeUpdated.id;
            dispatch(action({ id, name, avatarUrl: imgSrc }));
        }
    };

    const addNameView = <AddName playerName={name} onNameSet={onNameSet}/>;
    const addPhotoView = <AddPhoto photo={playerToBeUpdated?.avatarUrl || null} name={name} onPhotoSet={onPhotoSet}/>;

    return(
        <Modal footer={null} width={759} open={open} onCancel={onCancel}>
            <div data-testid="modal-add" className="flex flex-col justify-center items-center h-[400px] xl:h-[564px]">
                {userUpdateStep === 'photo' ? addPhotoView : addNameView }
            </div>
        </Modal>
    )
};

export default ModalAddPlayer;
